module.exports = __webpack_public_path__ + "img/dead-dry-hairy-tree-04.98fc379b.png";